import request from '@/utils/request'


// 查询加盟商/物业列表
export function listPropertyUser(query) {
  return request({
    url: '/franchisee/property//user/list',
    method: 'get',
    params: query
  })
}

// 查询加盟商/物业分页
export function pagePropertyUser(query) {
  return request({
    url: '/franchisee/property//user/page',
    method: 'get',
    params: query
  })
}

// 查询加盟商/物业详细
export function getPropertyUser(data) {
  return request({
    url: '/franchisee/property//user/detail',
    method: 'get',
    params: data
  })
}

// 新增加盟商/物业
export function addPropertyUser(data) {
  return request({
    url: '/franchisee/property//user/add',
    method: 'post',
    data: data
  })
}

// 修改加盟商/物业
export function updatePropertyUser(data) {
  return request({
    url: '/franchisee/property//user/edit',
    method: 'post',
    data: data
  })
}

// 删除加盟商/物业
export function delPropertyUser(data) {
  return request({
    url: '/franchisee/property//user/delete',
    method: 'post',
    data: data
  })
}
